import { Pagination } from "antd";
import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { ICON } from "../../assets";
import { types } from "../../components/Auth/reducer";
import { useAuth } from "../../components/Auth/useAuth";
import BasketManagement from "../../components/Basket/BasketsManagement/BasketManagement";
import { useCart } from "../../components/Carts/useCart";
import apis from "../../components/Clients/api";
import ApplicationHeader from "../../components/Headers/ApplicationHeader/ApplicationHeader";
import FSLoader from "../../components/Loaders/FSLoader";
import UiIcon from "../../components/ui/UiIcon";
import UiSearch from "../../components/ui/UiSearch";
import { navigate } from "../../routes";
import { admin } from "../../routes/admin";
import { main } from "../../routes/main";
import { useNotVrpRedirect } from "../../components/Auth/useVrpRedirect";
import "./userList.css";

function UserList() {
  useNotVrpRedirect();
  const [{ auth }, { isRoleOperator }] = useAuth();
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, isLoading] = useState(false);
  const [clients, setClients] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [totalItems, setTotalItems] = useState(0);
  const [sortBy, setSortBy] = useState("lastSalesRevenue");
  const [sortOrder, setSortOrder] = useState("DESC");

  const [carts] = useCart();

  const lang = "fr";

  const dispatch = useDispatch();

  async function fetchData() {
    const calculateBasketCounts = (id) => {
      return carts.carts.filter((el) => el.codcli == id).length || 0;
    };

    try {
      isLoading(true);
      const data = await apis.fetchClientsPaginated(
        currentPage,
        pageSize,
        searchTerm,
        sortBy,
        sortOrder,
      );

      if (data.success === true) {
        const responseData = data.payload.data || [];
        const pagination = data.payload.pagination || {};

        const _clients = responseData.map((client) => {
          return {
            id: client.CODCLI,
            name: client.NOMCLI,
            email: client.EMAIL,
            tel: client.TEL,
            codgrt: client.codgrt,
            address: client.RUE + client.VILLE + client.PAYS,
            basketCount: calculateBasketCounts(client.CODCLI),
            salesRevenue: client.salesRevenue || 0,
            lastSalesRevenue: client.lastSalesRevenue || 0,
            pointOfSale: client.pointOfSale,
          };
        });

        setClients(_clients);
        setTotalItems(pagination.totalItems || 0);
        isLoading(false);
      }
    } catch (error) {
      console.error("something went wrong", error);
      isLoading(false);
    }
  }

  useEffect(() => {
    if (isRoleOperator()) {
      dispatch({
        type: types.REMOVE_CLIENT_PROFILE,
      });
    }
    fetchData();
  }, [currentPage, pageSize, searchTerm, sortBy, sortOrder]);

  // Reset to first page when search term changes
  useEffect(() => {
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  }, [searchTerm]);

  const _handleOnEyeView = (client) => {
    dispatch({
      type: types.ADD_CLIENT_PROFILE,
      payload: client,
    });
    dispatch({
      type: types.DELETE_LOYALTY_REWARD,
    });
    navigate.push(main.HOME);
  };

  const _handleOnCartView = (client) => {
    if (!client) return;

    dispatch({
      type: types.ADD_CLIENT_PROFILE,
      payload: {
        id: client?.id,
        email: client?.email,
        name: client?.name,
        tel: client?.tel,
      },
    });
    dispatch({
      type: types.DELETE_LOYALTY_REWARD,
    });
    navigate.push(admin.VIEW_CART);
  };

  // Handle page change
  const handlePageChange = (page, size) => {
    if (size !== pageSize) {
      setPageSize(size);
      setCurrentPage(1); // Reset to first page when page size changes
    } else {
      setCurrentPage(page);
    }
  };

  const handleSort = (column) => {
    if (sortBy === column) {
      setSortOrder(sortOrder === "ASC" ? "DESC" : "ASC");
    } else {
      setSortBy(column);
      setSortOrder("ASC");
    }
  };

  const renderSortIndicator = (column) => {
    if (sortBy !== column) return null;
    return sortOrder === "ASC" ? " ▲" : " ▼";
  };

  function renderInputSearchContent() {
    const handleSearch = (term) => {
      setSearchTerm(term);
    };
    return (
      <React.Fragment>
        <div className="user-list-search">
          <UiSearch
            onSearch={handleSearch}
            value={searchTerm}
            disabled={loading}
          />
        </div>
      </React.Fragment>
    );
  }

  function renderTableContent() {
    if (clients.length === 0 && searchTerm) {
      return <span>Aucun utilisateur trouvé pour le client {searchTerm}</span>;
    }
    const renderTableBodyContent = () =>
      clients.map((client, index) => {
        return (
          <React.Fragment key={index}>
            <tr key={client.id}>
              <td
                style={
                  searchTerm
                    ? { padding: "1rem 0 1rem 1rem" }
                    : { padding: "1rem" }
                }
              >
                {client.basketCount ? (
                  <div className="user-list__table-icon">
                    <UiIcon icon={ICON.cartCheck} alt="cart-check" size="sm" />
                    {client.basketCount}
                  </div>
                ) : (
                  ""
                )}
              </td>
              <td>{client.name}</td>
              <td>{client.pointOfSale}</td>
              <td>{client.address}</td>
              <td>{client.email}</td>
              <td>{client.tel}</td>
              <td className="user-list__table-cell--revenue">
                € {client.salesRevenue?.toLocaleString(lang) || "0"}
              </td>
              <td className="user-list__table-cell--revenue">
                € {client.lastSalesRevenue?.toLocaleString(lang) || "0"}
              </td>
              <td className="user-list__table-cell--actions">
                <div className="user-list__table-buttons">
                  <UiIcon
                    icon={ICON.eyeView}
                    onClick={() => _handleOnEyeView(client)}
                    alt="eye-view"
                    size="md"
                  />
                  <UiIcon
                    icon={ICON.cartPlus}
                    onClick={() => _handleOnCartView(client)}
                    alt="cart-plus"
                    size="md"
                  />
                </div>
              </td>
            </tr>
          </React.Fragment>
        );
      });

    return (
      <React.Fragment>
        <div className={`user-list__table ${pageSize > 30 ? "scroll" : ""}`}>
          <table>
            <thead>
              <tr>
                <th></th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("name")}
                >
                  Client{renderSortIndicator("name")}
                </th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("pointOfSale")}
                >
                  Contact{renderSortIndicator("pointOfSale")}
                </th>
                <th>Adresse</th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("email")}
                >
                  E-mail{renderSortIndicator("email")}
                </th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("tel")}
                >
                  Téléphone{renderSortIndicator("tel")}
                </th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("salesRevenue")}
                >
                  chiffre d'affaires{renderSortIndicator("salesRevenue")}
                </th>
                <th
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSort("lastSalesRevenue")}
                >
                  chiffre d'affaires N-1
                  {renderSortIndicator("lastSalesRevenue")}
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>{renderTableBodyContent()}</tbody>
          </table>
        </div>
        <div className="user-list__pagination">
          <Pagination
            current={currentPage}
            pageSize={pageSize}
            total={totalItems}
            onChange={handlePageChange}
            onShowSizeChange={handlePageChange}
            showSizeChanger
            showTotal={(total, range) =>
              `${range[0]}-${range[1]} de ${total} clients`
            }
            pageSizeOptions={["30", "50", "100"]}
          />
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <ApplicationHeader />
      <BasketManagement />
      <Container className="user-list">
        <div className="user-list__container mt-3">
          {renderInputSearchContent()}
          <div className="user-list__table-wrapper">
            {loading && (
              <div className="user-list__loading-overlay">
                <FSLoader />
              </div>
            )}
            {renderTableContent()}
          </div>
        </div>
      </Container>
    </React.Fragment>
  );
}

export default UserList;
